// NPM imports
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import Select from 'react-select';

import SubHeader from '../../components/SubHeader';
import Tabs, { Tab } from '../../components/Tabs';
import Current from './pages/Current';
import Checkbox from '../../components/Checkbox';
import Search from '../../components/Search';
import Button from '../../components/Button';
import './styles.css';


import { getCurrentStock, getTotalStock, getListOfCompanies, setGroupedOption, exportStock } from '../../redux/stock';
import { getExportStockUI } from '../../redux/selectors';


// Component

class Stock extends Component {
  constructor(props) {
    super(props);

    const { match } = props;

    const tabs = [
      {
        text: 'Atual',
        path: `${match.path}/atual`,
        component: Current,
      },
      // {
      //   text: 'Movimentação',
      //   path: `${match.path}/movimentacao`,
      //   component: Movement,
      // },
    ];
    this.state = {
      tabs,
      selectedOption: '',
    };
  }

  componentDidMount = () => {
    this._getListOfCompanies();
  }

  _getListOfCompanies = (query = '') => {
    this.props.dispatch(getListOfCompanies(query));
  }

  _getCurrentStock = (query = '') => {
    const { dispatch } = this.props;
    dispatch(getCurrentStock(query));
    dispatch(getTotalStock(query));
  }

  _exportStock = () => {
    this.props.dispatch(exportStock());
  }

  _renderTabs = () => (
    <Tabs>
      {
        this.state.tabs.map(tab => (
          <Tab
            isActive={tab.path === this.props.location.pathname}
            onClick={() => this.props.history.push(tab.path)}
            key={tab.path}
          >
            {tab.text}
          </Tab>
        ))
      }
    </Tabs>
  );

  _renderRoutes = () => (
    <Switch>
      {
        this.state.tabs.map(tab => (
          <Route
            path={tab.path}
            component={tab.component}
            key={tab.path}
          />
        ))
      }
      {/* default tab */}
      <Redirect to={this.state.tabs[0].path} />
    </Switch>
  );

  handleChange = (selectedOption) => {
    const { dispatch } = this.props;
    this.setState({ selectedOption });
    if (selectedOption) {
      dispatch(getCurrentStock('', selectedOption.value));
      dispatch(getTotalStock('', selectedOption.value));
      return;
    }
    dispatch(getCurrentStock());
    dispatch(getTotalStock());
  }

  render() {
    const { selectedOption } = this.state;
    const {
      dispatch,
      grouped,
      listOfCompanies,
      exportStockUI,
    } = this.props;

    return (
      <div className='Stock__Container'>
        <SubHeader
          title="Estoque"
        />
        <div className="Stock__ControlsWrapper">
          <div className="Stock__Tab-Wrapper">
            {this._renderTabs()}
          </div>
          <div className="Stock__Controls">
            <div className="Stock__Checkbox-Wrapper">
              <Checkbox
                isWhite
                style={{ marginRight: 40 }}
                label="Agrupar lotes"
                onClick={() => { dispatch(setGroupedOption(!grouped)); }}
                isChecked={grouped}
              />
            </div>
            <div className="Stock__Select-Wrapper">
              <Select
                options={listOfCompanies.data}
                onChange={this.handleChange}
                placeholder="FILTRAR POR CNPJ"
                className="Stock__Select"
                noResultsText="Nenhum CNPJ Encontrado"
                value={selectedOption}
                clearable={false}
              />
            </div>
            <div className="Stock__Search-Wrapper">
              <Search
                className="Stock__search-form"
                onSearch={this._getCurrentStock}
              />
            </div>
            <div className="Stock__Export-Stock-Wrapper">
              <Button
                className="Stock__Export-Stock-Button"
                disabled={exportStockUI.isFetching}
                skin="tertiary"
                icon={exportStockUI.isFetching ? null : 'detailed-excel'}
                text={exportStockUI.isFetching ? 'Gerando arquivo' : null}
                onClick={this._exportStock}
              />
            </div>
          </div>
        </div>
        {this._renderRoutes()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  grouped: state.stock.grouped,
  listOfCompanies: state.stock.listOfCompanies,
  exportStockUI: getExportStockUI(state),
});


export default connect(mapStateToProps)(Stock);
